import * as R from 'ramda'
import { createSelector } from 'reselect'
import { getURLByDeviceType } from 'domain/context'
import { GetContext, GetHomePageUrl, GetLoginURL } from './context.types'
import { getScreenSize } from './'

export const getContext: GetContext = R.prop('context')

export const getHomePageUrl: GetHomePageUrl = createSelector(
  getContext,
  getScreenSize,
  (context, { large }) => getURLByDeviceType(context, large, 'homePageUrl')
)

export const getLoginURL: GetLoginURL = createSelector(
  getContext,
  getScreenSize,
  (context, { large }) => getURLByDeviceType(context, large, 'loginUrl')
)
